import React from 'react';
import {APP_BAR_HEIGHT, VERSION_APP_HEIGHT} from '../../../layouts/constants';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  iframe: {
    width: '100%',
    height: `calc(100vh - ${APP_BAR_HEIGHT + VERSION_APP_HEIGHT + 16}px)`,
  },
}));

export default function WalletPage() {
  const classes = useStyles();
  return (
    <iframe
      src="/admin/pages/wallet"
      title="wallet"
      frameborder="0"
      className={classes.iframe}
    ></iframe>
  );
}
